import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import InvoiceDetailPageUI from './InvoiceDetailPageUI.js'

class InvoiceDetailPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      order: null,
      invoice: null,
      invoiceItemList: null,
      filteredItemList: null,
      searchFilter: '',
      updateInvoiceMode: false,
      updateInvoiceItemsMode: false
    }
  }

  render() {
    return (
      <InvoiceDetailPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        order={this.state.order}
        invoice={this.state.invoice}
        invoiceItemList={this.state.invoiceItemList}
        filteredItemList={this.state.filteredItemList}
        searchFilter={this.state.searchFilter}
        // events
        onRefreshClick={this.onRefreshClick}
        onSearchFilterChange={this.onSearchFilterChange}
        // update modal
        updateInvoiceMode={this.state.updateInvoiceMode}
        onUpdateInvoiceClick={(event) => { this.setState({ updateInvoiceMode: true }) }}
        onCancelUpdateInvoice={(event) => { this.setState({ updateInvoiceMode: false }) }}
        onUpdateInvoiceComplete={this.onUpdateInvoiceComplete}
        // update invoice items modal
        updateInvoiceItemsMode={this.state.updateInvoiceItemsMode}
        onUpdateInvoiceItemsClick={(event) => { this.setState({ updateInvoiceItemsMode: true }) }}
        onCancelUpdateInvoiceItems={(event) => { this.setState({ updateInvoiceItemsMode: false }) }}
        onUpdateInvoiceItemsComplete={this.onUpdateInvoiceItemsComplete}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getInvoice(context)
    this.getInvoiceItems(context)
    this.getMessages(context)
  }

  getOrder(context, orderId) {
    let cacheManager = new CacheManager({
      resource: `/api/orders/${orderId}`,
      cacheKey: CacheKeys.Order(orderId),
      callback: this.getOrderCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getOrderCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      order: response.order,
    })
  }

  // getOrderItems(context, orderId) {
  //   if (!context.permissions) { // session expired for some reason
  //     localStorage.removeItem(LocalStorageKeys.Session)
  //     localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
  //     setTimeout(() => {
  //       window.location = '/pub/message?key=invalid_session'
  //     }, 10)
  //     return
  //   }

  //   let cacheManager = new CacheManager({
  //     resource: `/api/orders/${orderId}/orderItems`,
  //     cacheKey: CacheKeys.OrderItems(orderId),
  //     callback: this.getOrderItemsCallback,
  //     ttlInSecs: 600
  //   })
  //   cacheManager.getObject2(context)
  // }

  // getOrderItemsCallback = (response) => {
  //   let filtersStr = sessionStorage.getItem(CacheKeys.OrderItemsFilter(this.props.match.params.orderId))
  //   let filters = filtersStr ? JSON.parse(filtersStr) : {}

  //   this.setState({
  //     errorList: response.errorList,
  //     itemList: response.orderItemList
  //   })
  // }

  getInvoice(context) {
    let cacheManager = new CacheManager({
      resource: `/api/invoices/${this.props.match.params.invoiceId}`,
      cacheKey: CacheKeys.Invoice(this.props.match.params.invoiceId),
      callback: this.getInvoiceCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getInvoiceCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      invoice: response.invoice,
    })
    if (response.invoice != null)
      this.getOrder(this.props.context, response.invoice.customerOrderId)
  }

  getInvoiceItems(context) {
    let cacheManager = new CacheManager({
      resource: `/api/invoices/${this.props.match.params.invoiceId}/invoiceItems`,
      cacheKey: CacheKeys.InvoiceItems(this.props.match.params.invoiceId),
      callback: this.getInvoiceItemsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getInvoiceItemsCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.InvoiceItemsFilter(this.props.match.params.invoiceId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      invoiceItemList: response.invoiceItemList,
      filteredItemList: response.invoiceItemList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    this.applyFilters(response.invoiceItemList, filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(invoiceItemList, searchFilter) {
    let filteredList = invoiceItemList

    if (searchFilter)
      filteredList = filteredList.filter(item =>
        item.itemName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())
      )

    this.setState({ filteredItemList: filteredList })

    let filters = {
      searchFilter: searchFilter,
    }
    sessionStorage.setItem(CacheKeys.InvoiceItemsFilter(this.props.match.params.invoiceId), JSON.stringify(filters))
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.OrderItems(this.state.order.orderId))
    CacheManager.removeObject(CacheKeys.Invoice(this.props.match.params.invoiceId))
    CacheManager.removeObject(CacheKeys.InvoiceItems(this.props.match.params.invoiceId))
    /*this.setState({
      errorList: null,
      invoiceItemList: null,
      filteredItemList: null,
      invoice: null
    }, () => {*/
    this.getInvoice(context)
    this.getInvoiceItems(context)
    //})
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.invoiceItemList, searchFilter)
  }

  onUpdateInvoiceComplete = (invoice) => {
    CacheManager.removeObject(CacheKeys.Invoice(this.props.match.params.invoiceId))
    CacheManager.removeObject(CacheKeys.OrderInvoices(invoice.customerOrderId))
    this.setState({ invoice: invoice })
    setTimeout(() => {
      this.setState({ updateInvoiceMode: false })
    }, 2000)
  }

  onUpdateInvoiceItemsComplete = (response) => {
    CacheManager.removeObject(CacheKeys.OrderItems(response.customerInvoice.customerOrderId))
    CacheManager.removeObject(CacheKeys.InvoiceItems(response.customerInvoice.customerInvoiceId))
    CacheManager.removeObject(CacheKeys.Invoice(response.customerInvoice.customerInvoiceId))
    CacheManager.removeObject(CacheKeys.AccountStats(response.account.accountId))

    response.invoiceItemList.forEach(item => {
      item.selected = item.customerInvoiceId === this.props.match.params.invoiceId
    })

    let filtersStr = sessionStorage.getItem(CacheKeys.InvoiceItemsFilter(this.props.match.params.invoiceId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      invoiceItemList: response.invoiceItemList,
      order: response.customerOrder,
      invoice: response.customerInvoice,
      filteredItemList: response.invoiceItemList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    this.applyFilters(response.invoiceItemList, filters.searchFilter ? filters.searchFilter : '')

    setTimeout(() => {
      this.setState({ updateInvoiceItemsMode: false })
    }, 2000)
  }

  getMessages(context) {
    let arr = [
      'c_refresh', //done
      'c_add_inv_item',
      'c_no_item_msg',
      'c_invoice_date',
      'c_invoice_amount',
      'c_update_invoice',
      'c_status_unpaid',
      'c_status_paid',
      'c_cancelled',
      'c_last_sent',
      'c_invoice',
      'c_qty',
      'c_due_date',
      'c_status_done',
      'c_completion_date',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_invoice', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default withRouter(InvoiceDetailPageSF)
